import {Component, Input, OnInit} from '@angular/core';
import {BranchMeasurement, ComplexObject} from "../../CardStruct";
import {VariableValue} from "../../../variableDataBase/VariableValue";
import {VariableDataBase} from "../../../variableDataBase/variable-data-base.service";
import {sprintf} from "sprintf-js";

export interface Scale {
  min: number;
  max: number;

}


@Component({
  selector: 'app-branch-gauge-setting-measurement',
  templateUrl: './branch-gauge-setting-measurement.component.html',
  styleUrls: ['./branch-gauge-setting-measurement.component.css']
})


export class BranchGaugeSettingMeasurementComponent implements OnInit {
  @Input() mVariable: BranchMeasurement | undefined;
  @Input() sVariable: BranchMeasurement | undefined;
  @Input() description: string = "";
  @Input() scale: Scale | undefined;
  @Input() maxAlarm: BranchMeasurement | undefined;
  @Input() minAlarm: BranchMeasurement | undefined;


  mValue: &VariableValue = new VariableValue();
  sValue: &VariableValue = new VariableValue();
  maxAlarmValue: &VariableValue = new VariableValue();
  minAlarmValue: &VariableValue = new VariableValue();
  alarmColor: string =   "lightcoral";


  constructor(private variableDB: VariableDataBase) {
  }

  GetRandomInt(max: number) : number {
    return Math.floor(Math.random() * max);
  }

  ngOnInit(): void {
    if(this.mVariable)
      this.mValue = this.variableDB.AddValueByReference(this.mVariable.variable.id);
    if(this.sVariable)
      this.sValue = this.variableDB.AddValueByReference(this.sVariable.variable.id);
    if(this.maxAlarm)
      this.maxAlarmValue = this.variableDB.AddValueByReference(this.maxAlarm.variable.id);
    if(this.minAlarm)
      this.minAlarmValue = this.variableDB.AddValueByReference(this.minAlarm.variable.id);

    this.alarmColor = ((this.minAlarm) && (this.maxAlarm)) ?  "lightcoral" : "#106EA8FF";

  }

  GetLow(): number {
    if (this.minAlarm) return this.minAlarmValue.val;
    else
      return (this.scale) ? this.scale.min : 0;
  }

  GetHigh(): number {
    if (this.maxAlarm) return this.maxAlarmValue.val;
    else
      return (this.scale) ? this.scale.max : 1000;
  }

  GetMeasurement() {
    return this.mValue.val;
  }

  GetSetpoint() {
    return this.sValue.val;
  }

  GetDescription(): string  {
    return  this.description;
  }

  GetUnit(): string {
    return ( this.mVariable)  ? this.mVariable.variable.unit : "";
  }


  GetValueAsString(variable: VariableValue) : string
  {
    if(variable.IsInvalid())
      return "NaN";
    return sprintf("%5.1f", variable.val / 1);
  }

  GetMeasurementAsString(): string{
      if(this.mValue.IsInvalid())
        return "NaN";
      return sprintf("%6f", this.GetMeasurement() / 1);
  }

  GetSettingAsString(): string{
    if(this.sValue.IsInvalid())
      return "NaN";
    return sprintf("%6f", this.GetSetpoint() / 1);
  }

  Bottom() : number {
    return  (this.GetSetpoint() - this.RangeLeft());
  }

  RangeLeft() : number
  {
    return ((this.GetSetpoint() - this.GetLow()) / 2 ) * 3;
  }


  RangeRight() : number
  {
    return ((this.GetHigh() - this.GetSetpoint()) / 2 ) * 3;
  }

  Top() : number
  {
    return ((this.GetSetpoint() + this.GetHigh()) / 2 ) * 3;
  }

  GetLenght() :number{
    return (this.CheckValidGauge()) ? 1.7 : 0.6;
  }

  CheckValidGauge(): boolean
  {
    if(this.sValue.IsInvalid())
      return false;
    if(this.GetSetpoint() < this.Bottom())
      return false;
    if(this.GetSetpoint() > this.Top())
      return false;
    return true;
  }

  GetPointerValue()
  {
    if(this.CheckValidGauge() == false)
      return -10;
    if(this.GetMeasurement()  <= this.GetSetpoint() ) {
      // We are calculating for the left part of the scale
      return (this.GetMeasurement() - this.Bottom()) * (135 / this.RangeLeft());
    } else
    {
      return 135 + (this.GetMeasurement() - this.GetSetpoint()) * (135 / this.RangeRight());
    }
  }

  GetRight() : number{
    var rangeRight = (this.Top() - this.GetSetpoint());
    return 135 + (this.GetMeasurement() - this.GetSetpoint()) * (135 / rangeRight);

  }







  GetLeft() : number{
    var rangeLeft = (this.GetSetpoint() - this.Bottom());
    return (this.GetMeasurement() - this.Bottom()) * (135 / rangeLeft);

  }


  ScaleLeft(): number
  {
    // 25 - 5 = 20
    // 20 = voor 90GrC
    // 20 / 90 = 0,22GrC per BoogGraad
    // BoogGraad * 135 = schaal bereik
    var scaleLeftRange: number = ((this.GetSetpoint() - this.GetLow()) / 90) * 135;
    return scaleLeftRange;
  }


}
